import { useState, useEffect, useMemo, useRef } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { useDispatch } from 'react-redux';
import { modalStyles } from './modalStyles';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import { PreConditionsComponent } from '../../gritComponents';
import { AddTechnicalProfileComponent } from '../../gritComponents';
import { init_SelfAssertedProfile } from '../../../xmlParsing/initInterfaces';
import { Precondition, SelfAssertedProfile, NonInteractiveTechnicalProfile } from '../../../xmlParsing/interfaces';
import { updatePrecondition, resetDuplicateState } from './../../../store';
interface ModalComponentProps {
  header: string;
  type: 'add-precondition' | 'add-technicalprofile';
  data: any;
  journeyType: 'UserJourneys' | 'SubJourneys';
  close: any;
}

function ModalComponent({ type, header, data, journeyType, close }: ModalComponentProps) {
  const origData = useRef<Precondition[]>(data.preconditions || []);
  const [modifiedData, setModifiedData] = useState<Precondition[]>(data.preconditions || []);
  const [tpData, setTPData] = useState<SelfAssertedProfile | NonInteractiveTechnicalProfile>(
    init_SelfAssertedProfile(),
  );
  const [disabledButton, setDisabledButton] = useState<boolean>(true);
  const [flag, setFlag] = useState<boolean>(false);
  const dispatch = useDispatch();

  useEffect(() => {
    setModifiedData(data.preconditions);
  }, [origData]);

  useEffect(() => {
    if (type === 'add-precondition') {
      if (disabledButton) {
        flag && dispatch(resetDuplicateState());
      } else {
        if (!flag) {
          setFlag(true);
          dispatch(
            updatePrecondition({
              data: modifiedData,
              order: data['order'],
              journeyName: data['journeyName'],
              journeyType: journeyType,
            }),
          );
        }
      }
    }
  }, [disabledButton, flag]);

  const classes = modalStyles();
  return (
    <>
      <Modal
        disableEnforceFocus
        open={true}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            close(null);
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className={classes.boxStyle}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            {header}
          </Typography>
          <div className={cn(classes.flexRow, classes.policyBody)}>
            {type == 'add-precondition' && (
              <div>
                <PreConditionsComponent
                  type="orchestration"
                  data={modifiedData}
                  addHandler={(data: Precondition) => {
                    setModifiedData(modifiedData.concat([data]));
                    setFlag(false);
                  }}
                  deleteHandler={(data: Precondition[]) => {
                    setModifiedData(data);
                    setFlag(false);
                  }}
                  disableSubmit={(disable: boolean) => {
                    setDisabledButton(disable);
                  }}
                />
              </div>
            )}
            {type === 'add-technicalprofile' && (
              <div>
                <AddTechnicalProfileComponent
                  data={tpData}
                  addHandler={(data: any) => {
                    setTPData(data);
                  }}
                  disableSubmit={(disable: boolean) => {
                    setDisabledButton(disable);
                  }}
                />
              </div>
            )}
            <footer className={classes.footer}>
              <Button
                variant="contained"
                color="primary"
                disabled={disabledButton}
                onClick={() => {
                  if (type === 'add-precondition') {
                    close(modifiedData);
                  } else if (type === 'add-technicalprofile') {
                    close(tpData);
                  }
                }}
              >
                Submit
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  close(null);
                }}
              >
                Cancel
              </Button>
            </footer>
          </div>
        </Box>
      </Modal>
    </>
  );
}

// export default withAITracking(reactPlugin, ModalComponent);
export default ModalComponent;
